import type { NextPage } from 'next';
import useUser from '../auth/useUser';
import CompanySelector from 'ui/components/companySelector/company-selector';

const Home: NextPage = () => {
  const currentUser = useUser();

  return (
    <CompanySelector
      user={currentUser}
      options={{
        gascaribe: {
          path: '/GDC',
          role: 'get_invoice_batch_GDC',
        },
        gasguajira: {
          path: '/GDG',
          role: 'get_invoice_batch_GDG',
        },
        efigas: {
          path: '/EFG',
          role: 'get_invoice_batch_EFG',
        },
      }}
    />
  );
};

export default Home;
